import { render, staticRenderFns } from "./scriptCenter.vue?vue&type=template&id=4fb2fc48&scoped=true"
import script from "./scriptCenter.vue?vue&type=script&lang=js"
export * from "./scriptCenter.vue?vue&type=script&lang=js"
import style0 from "./scriptCenter.vue?vue&type=style&index=0&id=4fb2fc48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb2fc48",
  null
  
)

export default component.exports